import { QueryClient } from '@tanstack/react-query'

/**
 * Shared React Query client.
 * Configured with sensible defaults for a small-scale app.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
